$(document).ready(function() {
  $('iframe').each(function(index) {
    src = $('iframe')[index].src

    if (/youtube/i.test(src) && !/rel=0/i.test(src)) {
      $('iframe')[index].src = (src + '?rel=0');
    }
  });
});
